<p class="description">Porta</p>
<ul class="items-list">
  <li><span class="item">Aberta</span><span class="value"> {{statistic.openedPortion}}</span>
  / <span class="item">Fechada</span><span class="value"> {{statistic.closedPortion}}</span></li>
  <li><span class="item">Tempo médio aberta:</span><span class="value"> {{statistic.openedAverage}}</span></li>
  <li><span class="item">Tempo total aberta:</span><span class="value"> {{statistic.totalOpenTime}}</span></li>
</ul>
